import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import RegistrationHeader from "../../components/registration/RegistrationHeader";
import { useRegistrationData } from "../../utils/registrationUtils";
import { DetailsBox } from "../../components/DetailsComponent";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getItemInLocalStorage } from "../../services/localStorage";
import { Button } from "../../common/components/Button";
import backarrowIcon from "../../assets/images/back-arrow-icon.svg";
import { format } from "date-fns";
import calender from "../../assets/images/calendar.svg";
import locationlogo from "../../assets/images/locationlogo.svg";
import { getCall } from "../../services/apiService";
import Loader from "../../common/components/Loader";
import { Tooltip } from "@mui/material";
import { highlightMahatriaAndInfinitheism } from "../../common/components/HighlightMahatriaInfinitheism";
import Footer from "../../common/components/Footer";
import { CANCELLED, COMPLETED, OFFLINE_PENDING, STATUS, WARNING , WARNING_MESSAGES} from "../../constants/index";
import AlertPopup from "../../common/components/AlertPopup";
function groupQuestionsBySection(apiData: any[]): Record<
  number,
  {
    sectionName: string;
    sectionKey?: string;
    answers: {
      questionId: number;
      label: string;
      answer: string;
      type?: string;
      config?: string;
    }[];
  }
> {
  const grouped: Record<
    number,
    {
      sectionName: string;
      sectionKey?: string;
      answers: {
        questionId: number;
        label: string;
        answer: string;
        type?: string;
        config?: string;
      }[];
    }
  > = {};

  apiData.forEach((item) => {
    const sectionId = item.sectionId;
    if (!grouped[sectionId]) {
      grouped[sectionId] = {
        sectionName: item.sectionName,
        sectionKey: item.sectionKey,
        answers: [],
      };
    }
    grouped[sectionId].answers.push({
      questionId: item.questionId,
      label: item.questionLabel,
      answer: item.answer,
      type: item.questionType == "file" ? (item?.config?.filetype == "video" ? "video" : item.questionType)  : item.questionType,
      config: item.config,
    });
  });

  // Add section 4 questions to section 1, but do NOT render section 4 as a separate card
  if (grouped[1] && grouped[4]) {
    grouped[1].answers = [...grouped[1].answers, ...grouped[4].answers];
    delete grouped[4];
  }

  return Object.values(grouped);
}

const SummaryPage = () => {
  const [searchParams] = useSearchParams();
  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};
  const programId = searchParams.get("programId");
  const [rmNames, setRmNames] = useState([]);
  const navigate = useNavigate();
  const [alert, setAlert] = useState<{
    open: boolean;
    message: string[];
    type: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    onReupload? : () => void;
  }>({ open: false, message: [], type: "" });

  const {
    loading,
    apiError,
    programDetails,
    groupedAnswersData,
    userStatus,
    groupedQuestions,
    refetch,
  } = useRegistrationData(programId || "", seekerDetails.id);

  const [sectionData, setSectionData] = useState<
    Record<
      number,
      {
        sectionName: string;
        sectionKey?: string;
        answers: {
          questionId: number;
          label: string;
          answer: string;
          type?: string;
          config?: {
            helperText?: string;
          };
        }[];
      }
    >
  >({});

  useEffect(() => {
    const registrationId = userStatus?.id;
    if (registrationId) {
      getCall(`registration/${registrationId}/questions`, undefined, false)
        .then((response) => {
          // If your API response is { data: [...] }
          const apiData = response?.data.data || [];
          console.log("API Data:", apiData);
          const grouped = groupQuestionsBySection(apiData);
          setSectionData(grouped);
          //   console.log("Questions API response:", response);
        })
        .catch((error) => {
          console.error("Questions API error:", error);
        });
    }
  }, [userStatus?.id]);

  useEffect(() => {
  if (programDetails?.registrationWindowStatus == STATUS.CLOSED && (!userStatus?.isFreeSeat && (userStatus?.paymentDetails[0]?.paymentStatus != OFFLINE_PENDING && !userStatus?.paymentDetails[0]?.paymentStatus.includes(COMPLETED)))) {
    setAlert({
      open: true,
      message: WARNING_MESSAGES.REGIISTRATION_CLOSED,
      type: WARNING,
      confirmText: "okay",
      onConfirm: () => {
        navigate("/myspace/programs", { replace: true });
      },
    });
  } else if(programDetails?.registrationWindowStatus == STATUS.NOT_OPENED){
    setAlert({
          open: true,
          message: WARNING_MESSAGES.REGIISTRATION_NOT_OPENED,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {
            navigate("/myspace/programs", { replace: true });
          },
        });
  } 
    // console.log("userStatus != nu;;",userStatus?.registrationStatus )
  if(userStatus != null && userStatus?.registrationStatus == CANCELLED){
    setAlert({
          open: true,
          message: WARNING_MESSAGES.REG_CANCELLED,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {
            navigate("/myspace/programs", { replace: true });
          },
        });
  }
}, [userStatus]);

  useEffect(() => {
    if(groupedQuestions && groupedQuestions[1]?.hasData) {
   groupedQuestions[1]?.hasData.map((items)=>{
   if(items?.question.bindingKey === "rmContact")
   {
    const rmNames = items?.question?.questionOptionMaps
    setRmNames(rmNames);
   }
  })
  }
  },[groupedQuestions])

  if (loading) return <Loader type="large" />;
  if (apiError) return <div>Error loading data.</div>;

  const venue = programDetails?.venue || programDetails?.type?.venue || "-";
  const bannerImageUrl = programDetails?.bannerImageUrl || "";
  const bannerAnimationUrl = programDetails?.bannerAnimationUrl || "";

  // Format date/time
  let dateTime = "-";
  if (userStatus?.allocatedProgram?.startsAt && userStatus?.allocatedProgram?.endsAt) {
    try {
      const start = new Date(userStatus?.allocatedProgram?.startsAt);
      const end = new Date(userStatus?.allocatedProgram?.endsAt);
      dateTime = `${format(start, "dd MMM yyyy")} - ${format(end, "dd MMM yyyy")}`;
    } catch {
      dateTime = "-";
    }
  }
  const handleDragAndDropValue = (answer: string) => {
    try {
      const pref = JSON.parse(decodeURIComponent(answer));
      console.log("Decoded drag and drop value:", pref);
      return pref; // Return the JSON object
    } catch (e) {
      console.error("Invalid drag and drop value", e);
      return answer;
    }
  };

  return alert.open ?   (
    <div className={styles.container}>
      <div className={styles.header}>
      {alert.open && (
      <AlertPopup
        type={alert.type}
        message={alert.message}
        confirmText={alert?.confirmText ? alert.confirmText : ""}
        onConfirm={() => {
          if (alert?.onReupload) {
            alert.onReupload();
          } else if (alert?.onConfirm) {
            alert.onConfirm();
          }
          setAlert({ message: [], open: false, type: "" });
        }}
        cancelText={alert?.cancelText ? alert.cancelText : undefined}
        onCancel={() => {
          alert?.onCancel && alert.onCancel();
          setAlert({ message: [], open: false, type: "" });
        }}
      />
    )}
    </div>
    </div>
  ): (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src={backarrowIcon}
          alt="back arrow"
          className={styles.backArrow}
          onClick={() => navigate("/myspace/programs")}
        />
        <span className={styles.headerTitle}>Summary</span>
      </div>
      <div className={styles.formSection}>
        <div className={styles.content}>
          <h2 className={styles.heading}>Congratulations!</h2>
          <p className={styles.subHeading}>
            You have been blessed with&nbsp;
            {highlightMahatriaAndInfinitheism(userStatus?.allocatedProgram?.name)}
          </p>
        </div>
        <div className={styles.calendarContainer}>
          <div className={styles.sectionHeader}>
            <div className={styles.banner}>
              <RegistrationHeader bannerImageUrl={bannerImageUrl ?? undefined} bannerAnimationUrl={bannerAnimationUrl ?? undefined} />
            </div>
          </div>
        </div>
        <div className={styles.eventInfoBox}>
          <div className={styles.eventItem}>
          <img
              src={locationlogo}
              alt="location"
              className={styles.eventIcon}
            />
            {venue &&
              venue?.length > 40 ? (
              <Tooltip title={venue} arrow placement="top">
                <span>
                  {venue?.slice(0, 40)}
                  {"..."}
                </span>
              </Tooltip>
            ) : (
              venue
            )}
          </div>
          {/* <div className={styles.eventItem}>
            <img src={calender} alt="calendar" className={styles.eventIcon} />
            <span>{dateTime}</span>
          </div> */}
        </div>
        <div>
          {Object.values(sectionData)
          .filter(section => section.sectionKey !== "FS_GOODIES")
          .map((section, idx) => (
            <DetailsBox
              key={section.sectionName}
              cardTitle={section.sectionName}
              fields={section.answers.map((ans) => {
                let value = ans.answer;
                const rmObj = rmNames.find((item) => String(item.option.id) === String(value));
                if (rmObj) {
                value = rmObj.option.name;
              }
                let type = ans.type === "file" ? "file" : ans.type || "string";
                return {
                  label: ans.label,
                  value,
                  type,
                  helperText: ans?.config?.helperText,
                };
              })}
              fieldsPerRow={2}
            />
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <Button
            onClick={() => navigate("/myspace/programs")}
            buttonClassName={styles.confirmButton}
            buttonTextClassName={styles.confirmText}
          >
            home
          </Button>
        </div>
      </div>
       <div className={styles.footerContainer}>
            <Footer isHDBOnly = {true}/>
      </div>
    </div>
  );
};

export default SummaryPage;
